import React, { useState, useEffect, Suspense, useRef, useMemo } from "react";
import {
  ZapparCamera,
  InstantTracker,
  ZapparCanvas,
} from "@zappar/zappar-react-three-fiber";
import { useLoader, useFrame, useThree } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
// import { Html, Environment } from "@react-three/drei";
import { Html } from "./drei/Html.tsx";
import { Environment } from "./drei/Environment.tsx";
import {
  AnimationClip,
  AnimationMixer,
  AnimationUtils,
  LoopOnce,
  MeshBasicMaterial,
  LinearToneMapping,
  ACESFilmicToneMapping,
  LinearEncoding,
  sRGBEncoding,
  DoubleSide,
  BackSide,
  FrontSide,
  Box3,
  Frustum,
} from "three";
import { useSelector } from "@xstate/react";
import data from "../animData";
import { globalActor } from "../state/GlobalContextProvider";

window.as = 1;

// const modelUrl = process.env.PUBLIC_URL + "/Miebo_Animatic_0003_v2-v3.glb"
const modelUrl = process.env.PUBLIC_URL + "/Miebo_DraftAnimation_0004-v1.glb";
// useLoader.preload(GLTFLoader, modelUrl);
// useEnvironment.preload(process.env.PUBLIC_URL + "/Glow(KitchenHDR).HDR");
const frustum = new Frustum();

const boundingBox = new Box3();

function Model_(props) {
  const state = useSelector(globalActor, (snapshot) => snapshot.value);
  const prevState = useSelector(
    globalActor,
    (snapshot) => snapshot.context.prevState
  );
  const overrideTitle = useSelector(
    globalActor,
    (snapshot) => snapshot.context.overrideTitle
  );
  const showSidebar = useSelector(
    globalActor,
    (snapshot) => snapshot.context.showSidebar
  );

  // const result = useLoader(GLTFLoader, modelUrl, (loader) => {
  //   // loader.manager.onLoad = (_) => alert("loaded");
  //   const dracoLoader = new DRACOLoader();
  //   dracoLoader.setDecoderPath("/draco/");
  //   loader.setDRACOLoader(dracoLoader);
  // });
  // console.log("RESULT", result);
  const { result } = props;
  const { nodes, materials } = result;

  const mixerRef = useRef(null);
  const clipsRef = useRef(null);
  const actionRef = useRef(null);
  const group = React.useRef();

  useEffect(() => {
    // const ogMats = {};
    for (let key of ["eyelash"]) {
      const og = materials[key];
      if (!og) {
        continue;
      }
      // continue;

      const { map, alphaMap, color, opacity, side } = og;

      materials.eyelash = new MeshBasicMaterial({
        map,
        transparent: true,
        depthWrite: false,
      });
    }

    window.em = materials.eyelash;
    window.BackSide = BackSide;
    window.FrontSide = FrontSide;
    window.DoubleSide = DoubleSide;

    // const mixer = new AnimationMixer(result.scene);
    const mixer = new AnimationMixer(group.current);
    mixerRef.current = mixer;
    const clips = result.animations;

    const clip = AnimationClip.findByName(clips, "animation_0");

    const action = mixer.clipAction(clip);
    actionRef.current = action;

    mixer.addEventListener("finished", (e) => {
      const name = e.action._clip.name.toUpperCase() + "_DONE";

      globalActor.send({
        type: name,
      });
    });

    const cutClips = {};
    // for (let key in data) {
    //   const name = key + "Animation";
    //   const action = mixer.clipAction(
    //     subclip(clip, name, data[key][0], data[key][1])
    //   );
    //   action.clampWhenFinished = true;
    //   action.loop = LoopOnce;
    //   cutClips[name] = action;
    // }
    action.play();
    mixerRef.current = mixer;
    clipsRef.current = cutClips;
  }, []);

  // console.log("RSULT", result);

  const label1ref = useRef();
  useEffect(() => {
    const clips = clipsRef.current;

    for (let key in data) {
      if (state === key) {
        mixerRef.current.setTime(data[key][0] / 25);

        if (overrideTitle) {
          mixerRef.current.setTime((data[key][0] + 80) / 25);

          if (state === "blinkReflex1") {
            mixerRef.current.setTime((data[key][0] + 50) / 25);
          }
        }
        // if ( prevState === )
      } else if (state == key + "Animation") {
      }
    }
    if (state === "place") {
      mixerRef.current.setTime(0);
    }
  }, [state]);

  const cube = useRef();
  const t = useRef(0);

  useFrame((s, dt) => {
    let speed = state.match("Animation") ? dt : 0;
    speed *= window.as;
    if (mixerRef.current) {
      if (window.doTime) {
        window.doTime = false;
      }
      mixerRef.current.update(speed);
    }
    for (let key in data) {
      if (state == key + "Animation") {
        const endTime = data[key][1] / 25;

        if (mixerRef.current.time >= endTime) {
          console.log("REACHED end time", state, key, endTime);
          mixerRef.current.setTime(endTime);
          const name = state.toUpperCase() + "_DONE";
          globalActor.send({
            type: name,
          });
        }
      }
    }
    if (state === "blinkReflex3Animation") {
      if (mixerRef.current.time >= 1380 / 25) {
        globalActor.send({
          type: "HIDE_SECTION_TITLE",
        });
      }
      if (mixerRef.current.time >= 1360 / 25) {
        globalActor.send({
          type: "HIDE_DISCLAIMER",
        });
      }
    }
    t.current += dt;

    // for some reason the mixer animates the scene's root position, let's (dis)allow that
    group.current.position.set(0, 0, 0);
    // cube.current.scale.setScalar(100 + Math.sin(t.current) * 40);
  });

  // 1 - BoxTest_Saline_3
  //  2 - BoxTest_Saline_2
  // 3 - BoxTest_saline
  // 4 and 5 ( drop laesl ) BoxTest_Saline_5 and BoxTest_Saline_6
  // 6 - BoxTest_Saline_4 ( drop in eye )
  // 7 boxtest_saline_4 again

  const hiddenMaterial = useMemo(() => {
    // return new MeshBasicMaterial({ visible: false });
    return new MeshBasicMaterial({
      color: 0xff0000,
      visible: false,
    });
  });
  const lineMat = useMemo(() => {
    // return new MeshBasicMaterial({ visible: false });
    return new MeshBasicMaterial({
      color: 0xffffff,
    });
  });
  const debugMaterial = useMemo(() => {
    // return new MeshBasicMaterial({ visible: false });
    return new MeshBasicMaterial({
      color: 0xff0000,
      // visible: false,
    });
  });
  window.label1ref = label1ref;

  const debugRef = useRef();
  window.debugRef = debugRef;

  const inBoundsRef = useRef();

  const sceneLostTime = useRef(0);
  useFrame((s, dt) => {
    const { camera } = s;

    boundingBox.setFromObject(inBoundsRef.current);
    frustum.setFromProjectionMatrix(camera.projectionMatrix);
    frustum.planes.forEach(function (plane) {
      plane.applyMatrix4(camera.matrixWorld);
    });

    if (
      ["loading", "start", "disclaimer", "place", "whatPatients"].includes(
        state
      ) ||
      showSidebar
    ) {
      return;
    }
    if (frustum.intersectsBox(boundingBox)) {
      sceneLostTime.current = 0;
    } else {
      sceneLostTime.current += dt;
    }
    if (sceneLostTime.current > 5) {
      globalActor.send({ type: "SKIP_TO_START" });
    }
  });
  window.g = group;

  return (
    <>
      <group ref={group} {...props} dispose={null}>
        <group>
          <group name="ALL" position={[0, -0.066772, 0]}>
            <mesh scale={[1, 6, 1]} position-y={1} ref={inBoundsRef}>
              <boxBufferGeometry />
              <meshBasicMaterial
                color={0xff0000}
                transparent={true}
                opacity={0.5}
                visible={false}
              />
            </mesh>
            <group name="HERO">
              <group
                name="MainObject"
                position={[-0.376541, 0.742565, 0.035509]}
              >
                <group
                  name="EYE_1"
                  position={[4.16528, -0.457457, -0.333018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                  scale={0}
                >
                  <group
                    name="Eyelash_1"
                    position={[0.000955, -0.002084, 0.009943]}
                    rotation={[-0.029177, 0.153323, 0.001107]}
                    scale={0.013759}
                  >
                    <mesh
                      name="Eyelash"
                      geometry={nodes.Eyelash.geometry}
                      material={materials.eyelash}
                      morphTargetDictionary={
                        nodes.Eyelash.morphTargetDictionary
                      }
                      morphTargetInfluences={
                        nodes.Eyelash.morphTargetInfluences
                      }
                      position={[-0.728436, -106.58828, -6.473504]}
                      rotation={[0, -0.234774, 0]}
                      scale={61.692936}
                    />
                  </group>
                  <group
                    name="Lacrimal_1"
                    position={[0.000792, -0.00265, 0.008996]}
                    rotation={[-0.029177, 0.153323, 0.001107]}
                    scale={[0.013759, 0.013759, 0.012762]}
                  >
                    <mesh
                      name="Lacrimal"
                      geometry={nodes.Lacrimal.geometry}
                      material={materials.Lacrimal}
                      morphTargetDictionary={
                        nodes.Lacrimal.morphTargetDictionary
                      }
                      morphTargetInfluences={
                        nodes.Lacrimal.morphTargetInfluences
                      }
                      position={[-0.728436, -106.58828, -6.473504]}
                      rotation={[0, -0.234774, 0]}
                      scale={61.692936}
                    />
                  </group>
                  <group
                    name="SKIN_1"
                    position={[0.000886, -0.002714, 0.009994]}
                    rotation={[-0.029177, 0.153323, 0.001107]}
                    scale={0.013759}
                  >
                    <mesh
                      name="SKIN"
                      geometry={nodes.SKIN.geometry}
                      material={materials["PBR SKIN"]}
                      morphTargetDictionary={nodes.SKIN.morphTargetDictionary}
                      morphTargetInfluences={nodes.SKIN.morphTargetInfluences}
                      position={[-0.728436, -106.58828, -6.473504]}
                      rotation={[0, -0.234774, 0]}
                      scale={61.692936}
                    />
                  </group>
                  <mesh
                    name="EyeBall__Copy__(Copy)"
                    geometry={nodes["EyeBall__Copy__(Copy)"].geometry}
                    material={materials.Eyeball}
                    position={[-0.000001, -0.002415, -0.003577]}
                    rotation={[0.162812, 0.153532, 0.001093]}
                    scale={0.013759}
                  />
                </group>
                <group
                  name="MBO_BOTTLE_ALT"
                  position={[0.355957, -0.412818, 0]}
                  rotation={[0, 0, -0.002629]}
                >
                  <group
                    name="cap_new"
                    position={[-0.000037, 0.014084, 0]}
                    rotation={[0, 0, 0.002629]}
                    scale={5}
                  >
                    <mesh
                      name="Tube_1"
                      geometry={nodes.Tube_1.geometry}
                      material={materials["Cap&Collar"]}
                      position={[0.002013, 0.064599, 0.066752]}
                      rotation={[0, 0, -Math.PI]}
                    />
                    <mesh
                      name="Lathe_cap"
                      geometry={nodes.Lathe_cap.geometry}
                      material={materials["Cap&Collar"]}
                      position={[0, -0.001228, 0]}
                    />
                    <mesh
                      name="Loft_cap_grip"
                      geometry={nodes.Loft_cap_grip.geometry}
                      material={materials["Cap&Collar"]}
                      position={[0, 0.101265, 0]}
                    >
                      <mesh
                        name="Cap_1"
                        geometry={nodes.Cap_1.geometry}
                        material={materials["Cap&Collar"]}
                        position={[0, 0.052812, 0]}
                      />
                      <mesh
                        name="Cap_2"
                        geometry={nodes.Cap_2.geometry}
                        material={materials["Cap&Collar"]}
                        position={[0, -0.022339, 0]}
                      />
                    </mesh>
                  </group>
                  <group
                    name="COLLAR_NEW"
                    position={[0, 0.244767, 0]}
                    rotation={[0, 0.034907, 0]}
                    scale={5.2}
                  >
                    <group name="Boole" position={[-0.000083, -0.014822, 0]}>
                      <mesh
                        name="Tube"
                        geometry={nodes.Tube.geometry}
                        material={materials["Cap&Collar"]}
                        position={[0.000167, 0.009158, 0]}
                      />
                      <mesh
                        name="Extrude_2"
                        geometry={nodes.Extrude_2.geometry}
                        material={materials["Cap&Collar"]}
                        position={[0, -0.001978, 0]}
                      />
                    </group>
                    <mesh
                      name="Tube_1_2"
                      geometry={nodes.Tube_1_2.geometry}
                      material={materials["Cap&Collar"]}
                      position={[0.000083, 0.014822, 0]}
                    />
                  </group>
                  <group name="bottle">
                    <mesh
                      name="Lathe_dropper"
                      geometry={nodes.Lathe_dropper.geometry}
                      material={materials.Bottle}
                      scale={5}
                    />
                    <mesh
                      name="Sweep_Thread"
                      geometry={nodes.Sweep_Thread.geometry}
                      material={materials.Bottle}
                      scale={5}
                    >
                      <mesh
                        name="Rounding_1"
                        geometry={nodes.Rounding_1.geometry}
                        material={materials.SAline}
                        position={[0.043681, 0.090144, 0]}
                        rotation={[0.054831, 0.047073, -0.007864]}
                      >
                        <mesh
                          name="Cap_1_2"
                          geometry={nodes.Cap_1_2.geometry}
                          material={materials.SAline}
                        />
                      </mesh>
                      <mesh
                        name="Rounding_2"
                        geometry={nodes.Rounding_2.geometry}
                        material={materials.SAline}
                        position={[0.043678, 0.120249, 0.000055]}
                        rotation={[0.054829, -0.046765, 0.576868]}
                      >
                        <mesh
                          name="Cap_2_2"
                          geometry={nodes.Cap_2_2.geometry}
                          material={materials.SAline}
                        />
                      </mesh>
                    </mesh>
                    <mesh
                      name="Lathe_bottle"
                      geometry={nodes.Lathe_bottle.geometry}
                      material={materials.Bottle}
                      scale={5}
                    />
                  </group>
                  <mesh
                    name="LABEL"
                    geometry={nodes.LABEL.geometry}
                    material={materials.Label}
                    position={[0.417707, -0.553491, 0.556202]}
                    rotation={[0.266483, -0.125372, 2.441244]}
                  />
                </group>
                <group
                  name="Big_Drop__Saline_1"
                  position={[2.130596, -0.792302, -0.035509]}
                >
                  <mesh
                    name="Big_Drop__Saline"
                    geometry={nodes.Big_Drop__Saline.geometry}
                    material={materials.BigSalineTExture}
                    position={[-0.165589, 2.45, 0]}
                    rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                    scale={0}
                  />
                </group>
                <group
                  name="Big_Drop_Miebo_1"
                  position={[0.329415, -0.792302, -0.035509]}
                >
                  <mesh
                    name="Big_Drop_Miebo"
                    geometry={nodes.Big_Drop_Miebo.geometry}
                    material={materials.MieboDrop}
                    position={[0.018206, 2.140198, 0]}
                    rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                    scale={0}
                  />
                </group>
                <group name="Dotted" position={[0.182438, -0.200523, 0.017601]}>
                  <group
                    name="Null_1"
                    position={[-0.061211, 0.4773, 0.008153]}
                    rotation={[0, 0, -0.140936]}
                  >
                    <group
                      name="Fracture"
                      position={[0.696084, -0.777445, -0.10622]}
                      rotation={[0, 0, 0.324971]}
                    >
                      <mesh
                        name="Cube_1"
                        geometry={nodes.Cube_1.geometry}
                        material={materials["BoxText&Dotted"]}
                        position={[-0.227704, 1.110677, 0.101889]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                        scale={0}
                      />
                      <mesh
                        name="Cube_2"
                        geometry={nodes.Cube_2.geometry}
                        material={materials["BoxText&Dotted"]}
                        position={[-0.148485, 1.232376, 0.098459]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                        scale={0}
                      />
                      <mesh
                        name="Cube_3"
                        geometry={nodes.Cube_3.geometry}
                        material={materials["BoxText&Dotted"]}
                        position={[-0.069266, 1.354076, 0.09503]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                        scale={0}
                      />
                      <mesh
                        name="Cube_4"
                        geometry={nodes.Cube_4.geometry}
                        material={materials["BoxText&Dotted"]}
                        position={[0.009954, 1.475776, 0.0916]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                        scale={0}
                      />
                      <mesh
                        name="Cube_5"
                        geometry={nodes.Cube_5.geometry}
                        material={materials["BoxText&Dotted"]}
                        position={[0.089173, 1.597475, 0.08817]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                        scale={0}
                      />
                      <mesh
                        name="Cube_6"
                        geometry={nodes.Cube_6.geometry}
                        material={materials["BoxText&Dotted"]}
                        position={[0.168393, 1.719175, 0.084741]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                        scale={0}
                      />
                      <mesh
                        name="Cube_7"
                        geometry={nodes.Cube_7.geometry}
                        material={materials["BoxText&Dotted"]}
                        position={[0.247612, 1.840874, 0.081311]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                        scale={0}
                      />
                      <mesh
                        name="Cube_8"
                        geometry={nodes.Cube_8.geometry}
                        material={materials["BoxText&Dotted"]}
                        position={[0.326832, 1.962574, 0.077882]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                        scale={0}
                      />
                      <mesh
                        name="Cube_0_1"
                        geometry={nodes.Cube_0_1.geometry}
                        material={materials["BoxText&Dotted"]}
                        position={[-0.310522, 0.98345, 0.105475]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                        scale={0}
                      />
                    </group>
                  </group>
                  <group
                    name="Null_2"
                    position={[-0.14465, 0.512007, 0.008153]}
                    rotation={[0, 0, 0.137298]}
                  >
                    <group
                      name="Fracture_1"
                      position={[0.253201, -1.037416, -0.10622]}
                      rotation={[0, 0, -0.166656]}
                    >
                      <mesh
                        name="Cube_1_2"
                        geometry={nodes.Cube_1_2.geometry}
                        material={materials["BoxText&Dotted"]}
                        position={[-0.398574, 1.160052, 0.101803]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                        scale={0}
                      />
                      <mesh
                        name="Cube_2_2"
                        geometry={nodes.Cube_2_2.geometry}
                        material={materials["BoxText&Dotted"]}
                        position={[-0.380551, 1.299055, 0.098374]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                        scale={0}
                      />
                      <mesh
                        name="Cube_3_2"
                        geometry={nodes.Cube_3_2.geometry}
                        material={materials["BoxText&Dotted"]}
                        position={[-0.362527, 1.438057, 0.094944]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                        scale={0}
                      />
                      <mesh
                        name="Cube_4_2"
                        geometry={nodes.Cube_4_2.geometry}
                        material={materials["BoxText&Dotted"]}
                        position={[-0.344504, 1.577059, 0.091514]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                        scale={0}
                      />
                      <mesh
                        name="Cube_5_2"
                        geometry={nodes.Cube_5_2.geometry}
                        material={materials["BoxText&Dotted"]}
                        position={[-0.326481, 1.716062, 0.088085]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                        scale={0}
                      />
                      <mesh
                        name="Cube_6_2"
                        geometry={nodes.Cube_6_2.geometry}
                        material={materials["BoxText&Dotted"]}
                        position={[-0.308458, 1.855064, 0.084655]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                        scale={0}
                      />
                      <mesh
                        name="Cube_7_2"
                        geometry={nodes.Cube_7_2.geometry}
                        material={materials["BoxText&Dotted"]}
                        position={[-0.290434, 1.994066, 0.081225]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                        scale={0}
                      />
                      <mesh
                        name="Cube_8_2"
                        geometry={nodes.Cube_8_2.geometry}
                        material={materials["BoxText&Dotted"]}
                        position={[-0.272411, 2.133069, 0.077796]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                        scale={0}
                      />
                      <mesh
                        name="Cube_0_1_2"
                        geometry={nodes.Cube_0_1_2.geometry}
                        material={materials["BoxText&Dotted"]}
                        position={[-0.415548, 1.029138, 0.105033]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                        scale={0}
                      />
                    </group>
                  </group>
                </group>
                <group
                  name="Drop"
                  position={[-0.212187, 0.557152, 0.118287]}
                  rotation={[0.283732, 0.077561, -2.435501]}
                >
                  <mesh
                    name="Saline_Drop_1__Copy__1_2"
                    geometry={nodes.Saline_Drop_1__Copy__1_2.geometry}
                    material={materials.SmallSalineTExture}
                    position={[-0.583025, 0.557951, -0.175218]}
                    rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                    scale={0}
                  />
                  <mesh
                    name="Meibo_Drop_2"
                    geometry={nodes.Meibo_Drop_2.geometry}
                    material={materials.MieboDrop}
                    position={[-0.246366, 0.147628, -0.007874]}
                    rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                    scale={0}
                  />
                </group>
              </group>
            </group>
            <group name="OBJECTS">
              <group name="LinesVS" position={[0.279411, 0.066772, 0]}>
                <mesh
                  name="Polygon"
                  geometry={nodes.Polygon.geometry}
                  material={materials["BoxText&Dotted"]}
                  position={[0.465161, 2.908749, -0.009965]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                  scale={0}
                />
                <mesh
                  name="Polygon_2"
                  geometry={nodes.Polygon_2.geometry}
                  material={materials["BoxText&Dotted"]}
                  position={[0.465161, 2.066186, -0.009965]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                  scale={0}
                />
              </group>
              <group name="VS" position={[0.279411, 0.066772, 0]}>
                <mesh
                  name="Cylinder_2"
                  geometry={nodes.Cylinder_2.geometry}
                  material={materials.VS}
                  position={[0.464892, 2.486489, -0.012881]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                  scale={0}
                />
              </group>
              <group
                name="Arrow_1"
                position={[-0.02564, 0.066785, 0]}
                rotation={[0, 0, -0.002629]}
              >
                <group
                  name="Arrow_1_1"
                  position={[0.024949, 0, 0]}
                  rotation={[0, 0, -Math.PI]}
                >
                  <mesh
                    name="Arrow_1_3"
                    geometry={nodes.Arrow_1_3.geometry}
                    material={materials.Arrows}
                    position={[-1.541289, 0, -0.004626]}
                    rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                    scale={0}
                    onClick={(_) => globalActor.send({ type: "CONTINUE" })}
                  />
                </group>
                <group name="Arrow_1_2" position={[0.024949, 0, 0]}>
                  <mesh
                    name="Arrow_1_4"
                    geometry={nodes.Arrow_1_4.geometry}
                    material={materials.Arrows}
                    position={[-1.541289, 0, 0]}
                    rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                    scale={0}
                    onClick={(_) => globalActor.send({ type: "CONTINUE" })}
                  />
                </group>
              </group>
              <group
                name="BoxText_TIP"
                position={[-0.007677, -0.535394, 0.71141]}
              >
                <mesh
                  name="BoxTest_Saline"
                  geometry={nodes.BoxTest_Saline.geometry}
                  material={hiddenMaterial}
                  position={[0.000714, -0.009573, -0.004042]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                  scale={0}
                >
                  <Html
                    visible={true}
                    wrapperClass="LabelWrapper"
                    distanceFactor={5} // If set (default: undefined), children will be scaled by this factor, and also by distance to a PerspectiveCamera / zoom by a OrthographicCamera.
                    transform // If true, applies matrix3d transformations (default=false)
                    position-y={0}
                    scale={0.022}
                  >
                    <div className="Label3D" id="PrimeBottle3">
                      <h2>Tips for patients</h2>
                      <p>
                        Look at the tip of the bottle when dropping MIEBO in.
                        Using a mirror can also be helpful
                      </p>
                    </div>
                  </Html>
                </mesh>
              </group>
              <group
                name="BoxText_Turn_IP"
                position={[-0.007677, -0.535394, 0.71141]}
              >
                <mesh
                  name="BoxTest_Saline_2"
                  geometry={nodes.BoxTest_Saline_2.geometry}
                  material={hiddenMaterial}
                  position={[-0.007078, 0.210058, -0.003897]}
                  scale={0}
                >
                  <Html
                    visible={true}
                    wrapperClass="LabelWrapper"
                    distanceFactor={5} // If set (default: undefined), children will be scaled by this factor, and also by distance to a PerspectiveCamera / zoom by a OrthographicCamera.
                    transform // If true, applies matrix3d transformations (default=false)
                    position-y={0}
                    scale={0.025}
                  >
                    <div className="Label3D" id="PrimeBottle2">
                      <h2>
                        While squeezing, turn it upside down and release the
                        pressure
                      </h2>
                    </div>
                  </Html>
                </mesh>
              </group>
              <group
                name="BoxText_Unscrew"
                position={[-0.007677, -0.535394, 0.71141]}
              >
                <mesh
                  name="BoxTest_Saline_3"
                  geometry={nodes.BoxTest_Saline_3.geometry}
                  material={hiddenMaterial}
                  position={[0.000714, 0.097821, -0.002359]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                  scale={0}
                >
                  <Html
                    visible={true}
                    wrapperClass="LabelWrapper"
                    distanceFactor={5} // If set (default: undefined), children will be scaled by this factor, and also by distance to a PerspectiveCamera / zoom by a OrthographicCamera.
                    transform // If true, applies matrix3d transformations (default=false)
                    position-y={-0.0}
                    scale={0.02}
                  >
                    <div className="Label3D" id="PrimeBottle1">
                      <h2>Remove the cap and squeeze the bottle</h2>
                      <p>
                        Due to the low surface tension of MIEBO, it is important
                        to prime the bottle to ensure 1&nbsp;drop at a time is
                        administered
                      </p>
                    </div>
                  </Html>
                </mesh>
              </group>
              <group
                name="BoxText_Miebo_2_Crop"
                position={[-0.285867, 0.015132, -0.184174]}
              >
                <mesh
                  name="BoxTest_Saline_4"
                  geometry={nodes.BoxTest_Saline_4.geometry}
                  material={hiddenMaterial}
                  position={[0.05, 0.264419, 0.493111]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                  scale={0}
                >
                  <Html
                    visible={true}
                    wrapperClass="LabelWrapper"
                    distanceFactor={5} // If set (default: undefined), children will be scaled by this factor, and also by distance to a PerspectiveCamera / zoom by a OrthographicCamera.
                    transform // If true, applies matrix3d transformations (default=false)
                    position-y={-0.023}
                    position-x={0.003}
                    scale={0.042}
                  >
                    <div className="Label3D" id="BlinkReflexMiebo">
                      <h2>MIEBO</h2>
                      <p>
                        There may be{" "}
                        <strong>no ocular sensation or blink reflex</strong>{" "}
                        upon instillation
                      </p>
                    </div>
                  </Html>
                </mesh>
              </group>
              <group
                name="BoxText_Saline_2_Crop_1"
                position={[0.189526, -0.03102, 0.321507]}
              >
                <mesh
                  name="BoxTest_Saline_5"
                  geometry={nodes.BoxTest_Saline_5.geometry}
                  material={hiddenMaterial}
                  position={[-0.009493, 0.264419, 0.002362]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                  scale={0}
                >
                  <Html
                    visible={true}
                    wrapperClass="LabelWrapper"
                    distanceFactor={5} // If set (default: undefined), children will be scaled by this factor, and also by distance to a PerspectiveCamera / zoom by a OrthographicCamera.
                    transform // If true, applies matrix3d transformations (default=false)
                    position-y={-0.02}
                    scale={0.042}
                  >
                    <div className="Label3D" id="BlinkReflexAqueuous">
                      <h2>Aqueous formulations</h2>
                      <p>An ocular sensation or blink reflex may occur</p>
                    </div>
                  </Html>
                </mesh>
              </group>
              <group
                name="BoxText_Miebo_11"
                position={[-0.452403, 2.019148, 0.231017]}
              >
                <mesh
                  name="BoxTest_Saline_6"
                  geometry={nodes.BoxTest_Saline_6.geometry}
                  material={hiddenMaterial}
                  position={[-0.432557, -0.276295, 0.094978]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                  scale={0}
                >
                  <Html
                    visible={true}
                    wrapperClass="LabelWrapper"
                    distanceFactor={5} // If set (default: undefined), children will be scaled by this factor, and also by distance to a PerspectiveCamera / zoom by a OrthographicCamera.
                    transform // If true, applies matrix3d transformations (default=false)
                    position-y={-0.003}
                    position-x={-0.01}
                    scale={0.032}
                  >
                    <div className="Label3D" id="DropSizeMiebo">
                      <h2>MIEBO</h2>
                      <p>
                        The small drop size (11 µL) means MIEBO{" "}
                        <strong>may feel different</strong> from formulations
                        containing water
                      </p>
                    </div>
                  </Html>
                </mesh>
              </group>
              <group
                name="BoxText_Saline_11"
                position={[0.863355, 1.996812, 0.231017]}
              >
                <mesh
                  name="BoxTest_Saline_7"
                  geometry={nodes.BoxTest_Saline_7.geometry}
                  material={hiddenMaterial}
                  position={[-0.249286, -0.248633, 0.094978]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                  scale={0}
                >
                  <Html
                    visible={true}
                    wrapperClass="LabelWrapper"
                    distanceFactor={5} // If set (default: undefined), children will be scaled by this factor, and also by distance to a PerspectiveCamera / zoom by a OrthographicCamera.
                    transform // If true, applies matrix3d transformations (default=false)
                    position-y={-0.001}
                    position-x={-0.008}
                    scale={0.032}
                  >
                    <div className="Label3D" id="DropSizeAqueuous">
                      <h2>Aqueous formulations</h2>
                      <p>The typical drop size is ~30-50 μL</p>
                    </div>
                  </Html>
                </mesh>
              </group>
            </group>
            <group name="CAMS"></group>
          </group>
        </group>
      </group>
    </>
  );
}

export default function Scene(props) {
  // let [placementMode, setPlacementMode] = useState(true);
  const [started, setStarted] = useState(false);
  const [scale, setScale] = useState(50);

  const state = useSelector(globalActor, (snapshot) => snapshot.value);
  const placementMode = state === "place";

  const r = useRef();
  const t = useThree();
  useEffect((_) => {
    window.r = r;
    const { gl } = t;
    // console.log("GL", gl);
    // gl.toneMapping = LinearToneMapping;
    gl.toneMapping = ACESFilmicToneMapping;
    gl.outputEncoding = sRGBEncoding;

    // console.log(
    //   "THREE",
    //   t,
    //   LinearToneMapping,
    //   ACESFilmicToneMapping,
    //   LinearEncoding,
    //   sRGBEncoding
    // );
  });
  if (window.location.href.match("fake")) {
    return (
      <>
        <Environment
          // files={process.env.PUBLIC_URL + "/Glow(KitchenHDR).HDR"}
          map={props.env}
        ></Environment>
        <mesh
          rotation={[-Math.PI / 2, 0, 0]}
          // visible={true}
          scale={10}
          visible={placementMode}
        >
          <planeGeometry args={[1, 1, 10, 10]} />
          <meshBasicMaterial
            transparent={true}
            map={props.placeTex}
            side={DoubleSide}
            // color={0xff0000}
          />
        </mesh>
        <group visible={!placementMode} rotation={[0, 0, 0]}>
          {/* <mesh>
            <meshBasicMaterial color={0xff0000} />
            <boxBufferGeometry />
          </mesh> */}
          <Model_ result={props.model} />

          <ambientLight intensity={0.3} />
          <directionalLight intensity={1.5} position={[0.5, 0, 0.866]} />

          {/* <Model /> */}
        </group>
        {/* <directionalLight position={[2.5, 8, 5]} intensity={1.5} /> */}
      </>
    );
  }
  // console.log("SCNE PROPS ", props);

  return (
    <>
      <Environment
        // files={process.env.PUBLIC_URL + "/Glow(KitchenHDR).HDR"}
        map={props.env}
      ></Environment>
      <InstantTracker
        placementMode={placementMode}
        placementCameraOffset={[0, 0, -8]}
      >
        <mesh rotation={[-Math.PI / 2, 0, 0]} visible={placementMode}>
          <planeGeometry args={[2, 2, 10, 10]} />
          <meshBasicMaterial
            transparent={true}
            map={props.placeTex}
            side={DoubleSide}
          />
        </mesh>
        <group
          scale={2}
          visible={!placementMode}
          // rotation={[0, 0, 0]}
          // position={[0, 0, 0]}
          rotation={[-0.3, 0, 0]}
          position={[0, 0, 0]}
          ref={r}
        >
          <Model_ result={props.model} />

          <ambientLight intensity={0} />
          <directionalLight intensity={1.5} position={[0.5, 0, 0.866]} />

          {/* <Model /> */}
          {/* <mesh scale={0.3}>
            <meshBasicMaterial color={0x00ffff} />
            <boxBufferGeometry />
          </mesh> */}
        </group>
        {/* <mesh scale={1}>
          <meshBasicMaterial color={0x00ffff} />
          <boxBufferGeometry />
        </mesh> */}
      </InstantTracker>

      {/* <directionalLight position={[2.5, 8, 5]} intensity={1.5} /> */}
    </>
  );
}
